require("./bootstrap");

$(function () {

  // ページのトップにスクロール
  $('.top-scroll').on('click', function() {
    const speed = 500;
    const position = 0;
    $("html, body").animate({scrollTop: position}, speed, "swing");
    return false;
  });

   // コンテキストメニューの表示を防止
  $('img').on('contextmenu', function(e) {
    return false;
  });

  /*
   * 言語選択
   */
  $('.locale-select').on('change', function () {
    // 現在のURLをエンコード
    var modifiedUrl = window.appUrl;

    // 言語に応じてリダイレクト
    if (this.value == "en") {
      // 日本語から英語へ翻訳
      window.location.assign("https://translate.google.com/translate?hl=ja&sl=ja&tl=en&u=" + modifiedUrl);
    } else if (this.value == "cn") {
      // 日本語から中国語繁体字へ翻訳
      window.location.assign("https://translate.google.com/translate?hl=ja&sl=ja&tl=zh-TW&u=" + modifiedUrl);
    } else {
      // 日本語サイトにリダイレクト（元のURLに戻す）
      window.location.assign(modifiedUrl); // 日本語サイトに戻る
    }
});

  /*
   * googleサイト内検索
   */
  /*
  $('.search-icon').on('click', function(e) {
    e.preventDefault(); // デフォルトのリンク動作をキャンセル
    const $searchBox = $('.google-search');
    if ($searchBox.hasClass('active')) {
        $searchBox.removeClass('active');
         $('.search-icon').removeClass('active');
    } else {
        $searchBox.addClass('active');
        $('.search-icon').addClass('active');
    }
  });*/

  /*
  * drag 中はリンクしないように設定
  */
  var isDrag = false;
  $(document).on("mousedown", function () {
    isDrag = true;
  });
  $(document).on("mouseup mouseleave", function () {
    isDrag = false;
  });
  $(document).on("mousemove", function () {
    if (isDrag === true) {
      // console.log('dragging!');
    }
  });
  $("a").on("click", function (e) {
    if (isDrag == true) {
      e.preventDefault();
      return false;
    }
  });

  /*
   * スマホメニューボタン
   */
  $(".sp-menu-btn").on("click", function () {
    $(this).toggleClass("active");
    $(".sp-menu").toggleClass("active");
    $(".sp-menu-logo").toggleClass("active");
    $(".top-headeer-menu-pc").toggleClass("active");
    let $header = $(".sp-header");
    if ($header.hasClass("nav")) {
      $header.removeClass("nav");
    } else {
      $header.addClass("nav");
    }
  });

  $(".close-menu").on("click", function () {
    $(" body").removeClass("fixed");
    $(".sp-menu-btn").removeClass("active");
    $(".sp-menu").removeClass("active");
    $(".top-headeer-menu-pc").removeClass("active");
    let $header = $(".sp-header");
    if ($header.hasClass("nav")) {
      $header.removeClass("nav");
    }
  });

  $(".sub-category.has-children").on("click", function () {
      $(this).toggleClass("active");
      $(this).siblings('ul').slideToggle();
  });

  $(".close-menu-category").on("click", function () {
    $(this).parents('li').find('.sub-category').removeClass('active');
    $(this).closest('ul').slideToggle();
  });

  $(".js-indexBox-trigger").on("click", function () {
    $parent = $(this).parents(".js-indexBox");
    $content = $(".js-indexBox-content", $parent);
    let height = $content.data("height");
    $text = $(".js-trigger-text", $parent);

    if ($parent.hasClass("open")) {
      $content.css("height", height + "px");
      $parent.removeClass("open");
      $text.text("目次を開く");
    } else {
      $content.css("height", "auto");
      $parent.addClass("open");
      $text.text("目次を閉じる");
    }
  });

  $(".page-link-scroll a").on("click", function () {
    let width = $(window).innerWidth();
    var margin = 155;
    if (width <= 768) {
      margin = 80;
    }
    $("html, body").animate(
      { scrollTop: $($(this).attr("href")).offset().top - margin },
      "slow",
      "swing"
    );
    return false;
  });

  $(".js-faq-btn").on("click", function () {
    $parent = $(this).parents(".js-faq");
    $answer = $(".js-faq-a", $parent);

    $answer.slideToggle();
    $(".faq-btn", $parent).toggleClass("open");
  });

  $("#googleSearch, #googleSearchHeader").keypress(function(e) {
    if (e.keyCode == 13) {

        let siteDomain = ""; // 例: 'example.com'
        if($(this).hasClass('main-site')) {
          siteDomain = "";
        } else if($(this).hasClass('subsite')) {
          siteDomain = "/business";
        } else if($(this).hasClass('multilingual')) {
          let domain = $(this).data('lang');
          siteDomain = "/" + domain;
        }
        siteDomain = location.protocol + '//' + location.host + siteDomain;

        const searchValue = $(this).val(); // 現在の要素の値を取得
        //const siteDomain = 'www.kanagawa-kankou.or.jp'; // 例: 'example.com'
        //const url = 'https://www.kanagawa-kankou.or.jp/customSearch?q=' + encodeURIComponent(searchValue);

        const url = siteDomain + '/customSearch?q=' + encodeURIComponent(searchValue);
        window.open(url, "_blank");
        return false;
    }
  });

  // cookie
  const cookiePolicyName = "cookiePolicy",
    cookiePolicyValue = "ok",
    cookiePolicyFlag = localStorage.getItem(cookiePolicyName);
  if (cookiePolicyFlag != null) {
    const data = JSON.parse(cookiePolicyFlag);
    const current = new Date();
    if (
      data["value"] === cookiePolicyValue &&
      data["expire"] > current.getTime()
    ) {
      $("#cookieAgree").addClass("cc-hide");
    } else {
      popup();
    }
  } else {
    popup();
  }
  $("#cookieAgree .cookie-agree").on("click", function () {
    $("#cookieAgree").addClass("cc-hide");
    const current = new Date();
    current.setMonth(current.getMonth() + 1);
    let expires = "; expires=" + current.toUTCString();
    document.cookie =
      cookiePolicyName + "=" + cookiePolicyValue + expires + "; path=/";
    const item = {
      value: cookiePolicyValue,
      expire: current.getTime(),
    };
    localStorage.setItem(cookiePolicyName, JSON.stringify(item));
  });
  function popup() {
    window.onscroll = () => {
      if (window.pageYOffset) {
        $("#cookieAgree").addClass("is-show");
      }
    };
  }

  let currentValue = 0; // 現在の値を保持する変数
  let capacity = 0; // 定員数を保持する変数

  // デクリメントボタンのクリックイベントハンドラ
  $("#decrease-btn").on("click", function () {
    currentValue = parseInt($("#desiredNumber").val());
    const courseTxt = $("#selectExecution option:selected").text();
    const capacities = courseTxt.split("残:");
    if (capacities.length === 2) {
      capacity = Number(capacities[1]);
    }
    if (currentValue > 1) {
      $("#desiredNumber").val(currentValue - 1);
    }
    if (capacity >= parseInt($("#desiredNumber").val())) {
      $(".form-error").remove();
    }
  });

  // インクリメントボタンのクリックイベントハンドラ
  $("#increase-btn").on("click", function () {
    currentValue = parseInt($("#desiredNumber").val());
    const courseTxt = $("#selectExecution option:selected").text();
    const capacities = courseTxt.split("残:");
    if (capacities.length === 2) {
      capacity = Number(capacities[1]);
    }
    if (capacity > currentValue) {
      $("#desiredNumber").val(currentValue + 1);
    }
  });

  /*
  * フッターメニューのアコーディオン
  */
 /*
  if($(window).width() < 769) {
    $('.footer-menu-wrap dl dt').on('click', function() {
      console.log('footer menu click!');
      $(this).next('dd').slideToggle();
    });
  }
*/
});
